export const WORKING_HOURS_RANGE_IDS = {
  lessThan250: "less_than_250",
  between250And450: "250_to_450",
  between450And850: "450_to_850",
  moreThan850: "more_than_850",
};

export const WORKING_HOURS_RANGES = [
  {
    id: WORKING_HOURS_RANGE_IDS.lessThan250,
    min: undefined,
    max: 250,
  },
  {
    id: WORKING_HOURS_RANGE_IDS.between250And450,
    min: 250,
    max: 450,
  },
  {
    id: WORKING_HOURS_RANGE_IDS.between450And850,
    min: 450,
    max: 850,
  },
  {
    id: WORKING_HOURS_RANGE_IDS.moreThan850,
    min: 850,
    max: undefined,
  },
];

export const getWorkingHoursFilterOptions = (labels = {}) =>
  WORKING_HOURS_RANGES.map((range) => ({
    ...range,
    name: labels[range.id] || range.id,
  }));
